import { Resource, useResourceTypes } from "./useResources";
import {
  Card,
  Icon,
  IconButton,
  Stack,
  Title,
  useActions,
  useTheme
} from "@introist/react-foundation/v2";
import { FittedTitle } from "../../../components/atoms";

export const ResourceCard = ({
  resource,
  confirmRemoval,
  onRemove
}: {
  resource: Resource;
  confirmRemoval?: boolean;
  onRemove?: () => unknown;
}) => {
  const { theme } = useTheme();
  const { onConfirmAction } = useActions();
  const { resourceTypes } = useResourceTypes();

  const onConfirm = onConfirmAction(async () => onRemove!(), {
    title: "Confirm resource removal",
    description: "Are you sure you want to remove this resource?"
  });

  return (
    <Card
      style={{
        padding:
          "var(--spacing-small) var(--spacing-small) var(--spacing-small) var(--spacing-medium)"
      }}
    >
      <Stack>
        <Icon name="hardDrive" />
        <FittedTitle maxLength={60} showTooltip variant="bold">
          {resource.title ?? ""}
        </FittedTitle>
        <Title style={{ marginLeft: "auto" }}>
          {resourceTypes?.find(t => t.type === resource.type)?.title ?? ""}
        </Title>
        {onRemove && (
          <IconButton
            icon={<Icon name="crossSmall" color={theme.palette.foreground.dimmed} />}
            onClick={() => {
              confirmRemoval ? onConfirm() : onRemove();
            }}
          />
        )}
      </Stack>
    </Card>
  );
};
